import { Link, useLocation } from 'react-router-dom'
import { Button } from '../ui/Button'
import { Card, CardBody } from '../ui/Card'

export function NotFound() {
  const location = useLocation()

  return (
    <div className="mx-auto max-w-xl py-10">
      <Card>
        <CardBody className="text-center">
          <p className="font-display text-4xl font-semibold text-brand-200">404</p>

          <h1 className="mt-2 font-display text-xl font-semibold text-brand-900">
            There is no page here
          </h1>

          <p className="mt-2 text-sm text-ink-600">
            Nothing is served at <code className="font-mono text-ink-800">{location.pathname}</code>.
          </p>

          <div className="mt-6">
            <Link to="/">
              <Button variant="primary">Back to overview</Button>
            </Link>
          </div>
        </CardBody>
      </Card>
    </div>
  )
}
